module.exports = __webpack_public_path__ + "img/logo1.4760d963.png";